import AxiosConfig from './LensAxiosConfig'
import firebase from '../config/FirebaseConfig'

const getLensMetrics = async (lensId = null) => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const url = lensId ? `/metrics-registry/${lensId}?status=1` : '/metrics-registry?status=1'
  const { data } = await AxiosConfig.get(
    url,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )
  return data
}

export default {
  getLensMetrics
}
